"use client";

import { env } from "@ept/env/src/env-frontend";
import { ReactNode, createContext, useCallback, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
type Socket = ReturnType<typeof io>;

// TODO: for the love of god please test this when using it in a component alongside local-council
export const SocketContext = createContext<{
  connect: (...args: Parameters<Socket["connect"]>) => ReturnType<Socket["connect"]>;
  disconnect: (...args: Parameters<Socket["disconnect"]>) => ReturnType<Socket["disconnect"]>;
  emit: (...args: Parameters<Socket["emit"]>) => ReturnType<Socket["emit"]>;
  on: (...args: Parameters<Socket["on"]>) => ReturnType<Socket["on"]>;
  off: (...args: Parameters<Socket["off"]>) => ReturnType<Socket["off"]>;
} | undefined>(undefined);
type SocketProviderProps = {
  children: ReactNode;
};
export const SocketProvider = (props: SocketProviderProps) => {
  const socket = io(env.NEXT_PUBLIC_WEBSOCKET_HOST, {
    autoConnect: false
  });
  socket.on("error", (error: string) => {
    toast.error(error);
  });
  const [connected, setConnected] = useState(0);
  const _connect = useCallback((...args: Parameters<typeof socket.connect>) => {
    setConnected(prev => {
      if (prev === 0) {
        socket.connect(...args);
      }
      return prev + 1;
    });
  }, [setConnected, socket]);
  const _disconnect = useCallback((...args: Parameters<typeof socket.disconnect>) => {
    setConnected(prev => {
      if (prev === 1) {
        socket.disconnect(...args);
      }
      return prev - 1;
    });
  }, [setConnected, socket]);
  const connect = (...args: Parameters<typeof socket.connect>) => {
    _connect(...args);
    return socket;
  };
  const disconnect = (...args: Parameters<typeof socket.disconnect>) => {
    _disconnect(...args);
    return socket;
  };
  const emit = (...args: Parameters<typeof socket.emit>) => {
    return socket.emit(...args);
  };
  const on = (...args: Parameters<typeof socket.on>) => {
    return socket.on(...args);
  };
  const off = (...args: Parameters<typeof socket.off>) => {
    return socket.off(...args);
  };
  return <SocketContext.Provider value={{
    connect,
    disconnect,
    emit,
    on,
    off
  }} data-sentry-element="unknown" data-sentry-component="SocketProvider" data-sentry-source-file="Socket.tsx">
      {props.children}
    </SocketContext.Provider>;
};